import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import FilterContingencia from 'views/security/contingencia/filterContingencia'; // Importing FilterContingencia component
import TableContingencia from 'views/security/contingencia/tableContingencia'; // Importing TableContingencia component
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the Contingencia view.
 * @extends JetView
 */
export default class ContingenciaView extends JetView {
    /**
     * Configures the UI components of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const theme = this.app.config.theme; // Current theme configuration
        const toolbar = {
            view: 'toolbar', // Toolbar component
            id: 'toolbar', // Unique identifier for the toolbar
            css: 'highlighted_header header6', // CSS classes for styling
            paddingX: 5, // Horizontal padding
            paddingY: 5, // Vertical padding
            height: 40, // Height of the toolbar
            cols: [
                // Columns within the toolbar
                {
                    view: 'select', // Dropdown for selecting page size
                    options: ['10', '20', '50', '100'], // Options for page size
                    width: 70, // Width of the dropdown
                    on: {
                        onChange: function () {
                            // Event handler for change event
                            $$('datatable').getPager().config.size = this.getValue() * 1; // Update pager size
                            $$('datatable').refresh(); // Refresh the datatable
                        },
                    },
                },
                {
                    view: 'pager', // Pager component for pagination
                    id: 'pagerA', // Unique identifier for the pager
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}', // Template for pager buttons
                    autosize: false, // Disable autosizing
                    height: 35, // Height of the pager
                    size: devConfig.getDefaultDataFetch(), // Default data fetch size from config
                },
                {
                    view: 'richselect', // Rich select for export options
                    name: 'Export', // Name of the select
                    id: 'Export', // Unique identifier for the select
                    width: 120, // Width of the rich select
                    placeholder: _('Exportar'), // Placeholder text
                    options: [
                        // Export options
                        { id: '1', value: 'Excel' }, // Excel export option
                        { id: '2', value: 'PDF' }, // PDF export option
                    ],
                    on: {
                        onChange: function (value) {
                            // Event handler for change event
                            if (value == 1) {
                                // If Excel is selected
                                var table = $$('datatable'); // Get the datatable
                                for (var j = 0; j < table.config.columns.length; j++) {
                                    // Iterate through columns
                                    if (table.config.columns[j].exportType) {
                                        // Check for export type
                                        delete table.config.columns[j].format; // Remove format for export
                                    }
                                }
                                webix.toExcel(table, {
                                    // Export to Excel
                                    filename:
                                        'Virtualsoft - ' +
                                        new Date()
                                            .toLocaleString('en-GB', {
                                                hour12: true,
                                            }) // Filename with timestamp
                                            .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1') // Format date
                                            .replace(/[\/:]/g, '_') // Replace slashes and colons
                                            .toUpperCase() +
                                        ' - ' +
                                        ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                        'Contingencia', // Append data count
                                    ignore: {
                                        // Ignore specific titles during export
                                        detailTittle: true,
                                        ActionTittle: true,
                                    },
                                });
                            } else if (value == 2) {
                                // If PDF is selected
                                webix.toPDF($$('datatable'), {
                                    // Export to PDF
                                    filename:
                                        'Virtualsoft - ' +
                                        new Date()
                                            .toLocaleString('en-GB', {
                                                hour12: true,
                                            }) // Filename with timestamp
                                            .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1') // Format date
                                            .replace(/[\/:]/g, '_') // Replace slashes and colons
                                            .toUpperCase() +
                                        ' - ' +
                                        ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                        'Contingencia', // Append data count
                                    autowidth: true, // Enable auto width for PDF
                                    ignore: {
                                        // Ignore specific titles during export
                                        detailTittle: true,
                                        ActionTittle: true,
                                    },
                                });
                            }
                            $$('Export').setValue(''); // Reset the export selection
                        },
                    },
                },
            ],
        };
        const left = {
            css: 'int-left', // CSS class for left section
            rows: [
                // Rows in the left section
                {
                    view: 'toolbar', // Toolbar for the left section
                    css: theme, // Apply current theme
                    elements: [
                        // Elements in the toolbar
                        { view: 'label', label: _('Contingencia') }, // Label for the toolbar
                        {
                            type: 'wide', // Wide button for search
                            css: 'close-bottom', // CSS class for styling
                            id: 'button-search', // Unique identifier for the button
                            cols: [
                                // Columns within the button
                                {
                                    view: 'icon', // Icon for search
                                    icon: 'wxi-search', // Search icon
                                    bottom: 20, // Bottom margin
                                    right: 35, // Right margin
                                    width: 30, // Width of the icon
                                    height: 30, // Height of the icon
                                    click: () => {
                                        // Click event handler
                                        $$('filterPopup').show(); // Show filter popup
                                    },
                                },
                            ],
                        },
                        {
                            type: 'wide', // Wide button for close
                            css: 'close-bottom', // CSS class for styling
                            cols: [
                                // Columns within the button
                                {
                                    view: 'icon', // Icon for close
                                    icon: 'wxi-close', // Close icon
                                    bottom: 20, // Bottom margin
                                    right: 35, // Right margin
                                    width: 30, // Width of the icon
                                    height: 30, // Height of the icon
                                    click: () => this.show('/top/dashboard'), // Click event to navigate to dashboard
                                },
                            ],
                        },
                    ],
                },
                FilterContingencia, // Include the FilterContingencia component
                TableContingencia, // Include the TableContingencia component
                toolbar, // Include the toolbar
            ],
        };
        webix.ui.fullScreen(); // Set the UI to full screen mode
        return {
            id: 'a5', // Unique identifier for the form
            type: 'clean', // Clean type for the form
            view: 'form', // Form view
            scroll: 'y', // Enable vertical scrolling
            rows: [
                // Rows in the form
                {
                    responsive: 'a5', // Responsive design for the form
                    type: 'wide', // Wide type for the column
                    cols: [left], // Include the left section
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event handlers.
     * @param {Object} grid - The grid object.
     */
    init(grid) {
        webix.ready(function () {
            // Wait for Webix to be ready
            if (screen.width < 500 || screen.height < 500) {
                // Check for small screen size
                var childs = $$('toolbar').getChildViews(); // Get child views of the toolbar
                $$('toolbar').removeView(childs[2]); // Remove the third child view
                $$('pagerA').define('group', 1); // Define pager group
            }
            if (screen.width > 500 && screen.height > 500) {
                // Check for larger screen size
                $$('button-search').hide(); // Hide the search button
            }
            $.fn.scrollBottom = function () {
                // Add scrollBottom function to jQuery
                return $(document).height() - this.scrollTop() - this.height(); // Calculate scroll bottom position
            };
        });
    }
}

// FILE DOCUMENTED
